import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import Grid from '@material-ui/core/Grid';
import { BaseModal } from 'components/UI';
import { Formik, Form, Field } from 'formik';
import { AuthActions } from 'state/modules/auth';
import { usersActions } from 'state/modules/users';
import { TextField } from 'components/FormFields';
import { useDispatch, useSelector } from 'react-redux';

const ChangeAccountInfoModal = ({ open, user, id, handleClick }) => {
  const formSchema = Yup.object().shape({
    last_name: Yup.string(),
    first_name: Yup.string(),
    middle_name: Yup.string(),
  });

  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { fetchingUpdateAccount } = useSelector((state) => state.auth);
  const { fetchedUpdateUserSuccess } = useSelector((state) => state.users);

  useEffect(() => {
    if (fetchedUpdateUserSuccess) {
      handleClick();
      dispatch(usersActions.resetUpdateUser());
    }
  }, [fetchedUpdateUserSuccess, handleClick, dispatch]);

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      loading={fetchingUpdateAccount}
      title={i18n.t('account.update_info')}
      enterButtonLabel={i18n.t('account.update_info')}
    >
      <Formik
        innerRef={formRef}
        initialValues={{
          last_name: user.last_name || '',
          first_name: user.first_name || '',
          middle_name: user.middle_name || '',
        }}
        onSubmit={(values) => {
          values.id = id;
          dispatch(
            AuthActions.fetchUpdateAccount(values, 'info', handleClick, {
              type: 'success',
              message: 'account.change_account_success',
            })
          );
        }}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Grid datacy="update-account-modal" container spacing={2}>
              <Grid item xs={12}>
                <Field
                  margin="none"
                  type="text"
                  name="first_name"
                  component={TextField}
                  label={i18n.t('fields.first_name')}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  type="text"
                  name="middle_name"
                  component={TextField}
                  label={i18n.t('fields.middle_name')}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  type="text"
                  name="last_name"
                  component={TextField}
                  label={i18n.t('fields.last_name')}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

ChangeAccountInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeAccountInfoModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeAccountInfoModal;
